import { Button, Switch } from "@flat-ui";
import {
  DevToolItem,
  FeatureToggle,
} from "@components/dev-features-dialog/features";
import { DevPageItem } from "@components/dev-features-dialog/dev-pages";
import {
  isToolButtonItem,
  isToolToggleItem,
} from "@components/dev-features-dialog/features-utils";

/** Requires overflow hidden because the switch grows a bit when toggled and causes layout shift */
const SWITCH_SX = { justifySelf: "end", overflow: "hidden" };

/** @returns The switch that modifies the state of the feature */
export function renderFeatureAction(item: FeatureToggle): React.JSX.Element {
  return (
    <Switch
      checked={item.isEnabled}
      onToggle={() => item.onToggle(!item.isEnabled)}
      label=""
      sx={SWITCH_SX}
    />
  );
}

/** @returns The switch or the button that modifies the state of the tool */
export function renderToolAction(item: DevToolItem): React.JSX.Element {
  return (
    <>
      {isToolToggleItem(item) && (
        <Switch
          checked={!!item.isEnabled}
          onToggle={() => item.onToggle?.(!item.isEnabled)}
          label=""
          sx={SWITCH_SX}
        />
      )}
      {isToolButtonItem(item) && (
        <Button variant="secondary" onClick={item.onClick} size="s">
          {item.buttonText}
        </Button>
      )}
    </>
  );
}

/** @returns The button that lets the user navigate to the page */
export function renderPageAction(item: DevPageItem): React.JSX.Element {
  return (
    <Button variant="secondary" onClick={item.onOpen} size="s">
      Open
    </Button>
  );
}
